// API Url Constants

export default {
    TRAVEL_NESHAN_GEOCODING: "v1/travel/neshan/geocoding",
    TRAVEL_NESHAN_ADDRESS: "v1/travel/neshan/address",
    TRAVEL_NESHAN_DIRECTION: "v1/travel/neshan/direction",
    TRAVEL_TRAVEL_PROVINCE: "v1/travel/travel/province",
    TRAVEL_TRAVEL_OWNER: "v1/travel/travel/owner",
    TRAVEL_TRAVEL_CAR: "v1/travel/travel/car",
    TRAVEL_TRAVEL_CREATE: "v1/travel/travel",
    TRAVEL_TRAVEL_VIEW: "v1/travel/travel/view",
    TRAVEL_TRAVEL_PAGINATE: "v1/travel/travel/paginate",
    TRAVEL_TRAVEL_MY_PAGINATE: "v1/travel/travel/my/paginate",
    TRAVEL_PAYMENT_ZARINPAL_REQUEST: "v1/travel/payment/zarinpal-request",
    TRAVEL_PAYMENT_SEP_REQUEST: "v1/travel/payment/sep-request",
    TRAVEL_PAYMENT_PEP_REQUEST: "v1/travel/payment/pep-request",
    TRAVEL_BOOKING_CANCEL: "v1/travel/booking/cancel/",

    USER_MANAGEMENT_AUTH_SIGN_IN: "v1/user-management/auth/sign-in",
    USER_MANAGEMENT_AUTH_VERIFY_CODE: "v1/user-management/auth/verify-code",
    USER_MANAGEMENT_AUTH_PROFILE: "v1/user-management/auth/profile",
    USER_MANAGEMENT_AUTH_UPDATE_PROFILE: "v1/user-management/auth/update-profile",
    USER_MANAGEMENT_AUTH_CAPTCHA: "v1/user-management/auth/captcha",
}
